import React from 'react';
import ReactDOM from 'react-dom';
import ReactTable from 'reactable';

var Table = Reactable.Table,
    Thead = Reactable.Thead,
    Th = Reactable.Th,
    Tr = Reactable.Tr,
    Td = Reactable.Td;

export class ContactTable extends React.Component {
    constructor(props){
        super(props);
    }

    shouldComponentUpdate(nextProps, nextState){
        if(this.props.activeRegion !== nextProps.activeRegion || this.props.loadingDealers !== nextProps.loadingDealers){
            return true;
        }
        return false;
    }

    render() {
        if(this.props.loadingDealers){
            return <p>{this.props.translations.loading}</p>;
        }
        else if(this.props.activeRegion.Contacts === undefined || this.props.activeRegion.IsInternational){
            return <p></p>;
        }
        
        //Set itemsPerPage to 0 to disable pagination if dealers is less than 15
        let itemsPerPage = this.props.activeRegion.Contacts.length > 15 ? 15 : 0;
               
        return (
            <div>
                <div id="table-wrapper" className="collapse in">
                    <Table className="table contact-table"
                        id="table"
                        sortable={['name', 'title', 'area']}
                        defaultSort={{column:"name"}}
                        noDataText={this.props.translations.noDealersFound}
                        filterPlaceholder={this.props.translations.searchPlaceholder}
                        itemsPerPage={itemsPerPage}
                        previousPageLabel='<' nextPageLabel='>'  >
                        <Thead>
                            <Th column="name">
                                {this.props.translations.headerContact}
                                <div className="sort-wrapper">
                                    <div className="sort-arrow-up sort-arrow"></div>
                                    <div className="sort-arrow-down sort-arrow"></div>
                                </div>
                            </Th>
                            <Th column="title" className="hide-mobile-extrasmall">
                                {this.props.translations.headerTitle}
                                <div className="sort-wrapper">
                                    <div className="sort-arrow-up sort-arrow"></div>
                                    <div className="sort-arrow-down sort-arrow"></div>
                                </div>
                            </Th>
                            <Th column="area" className="hide-mobile">
                                {this.props.translations.headerArea}
                                <div className="sort-wrapper">
                                    <div className="sort-arrow-up sort-arrow"></div>
                                    <div className="sort-arrow-down sort-arrow"></div>
                                </div>
                            </Th>
                            <Th column="mobile" className="center">
                                {this.props.translations.headerPhone}
                            </Th>
                            <Th column="email" className="hide-mobile center">
                                {this.props.translations.headerEmail}
                            </Th>
                    </Thead>
                    {this.props.activeRegion.Contacts.map((contact) => {
                        return this.renderTable(contact);
                    })}
                </Table>
            </div>
        </div>);
    }

    renderTable(contact){ var row =
        <Tr key={contact.Id} id={contact.Id} onClick={(event) => this.props.onDealerClick(contact, event)}>
            <Td column="name">
                {contact.Name}
            </Td>
            <Td column="title" className="hide-mobile-extrasmall">
                {contact.Title}
            </Td>            
            <Td column="area" className="hide-mobile">
                {contact.Area}
            </Td>            
            <Td column="mobile" className="center" value={contact.MobilePhone}>
                <span className="icon-phone" />
            </Td>
            <Td column="email" className="hide-mobile center" value={contact.Email}>
                <a href={"mailto:" + contact.Email} target="_self" title={contact.Email}><span className="icon-envelop2 no-modal"></span></a>
            </Td>
        </Tr>;
        return row;
    }
}